<template>
  <div class="footer-navigation">
    <grid-container>
      <ul class="footer-navigation__list">
        <grid-row>
          <li
            v-for="(link, i) in links"
            :key="i"
            class="footer-navigation__item"
          >
            <router-link :to="link.to" class="footer-navigation__link">
              <span class="footer-navigation__link-arrow"> → </span><br>
              {{ $t(link.label) }}
            </router-link>
          </li>
        </grid-row>
      </ul>
    </grid-container>
  </div>
</template>

<script>
export default {
  props: {
    links: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer-navigation {
    @include vertical-space((bottom: 1, top: 1), padding);

    @include media-up(md) {
      @include vertical-space((bottom: 1, top: 6), padding);
    }

    &__list {
      @include reset-list;
    }

    &__item {
      @include grid-column((xs: 12, md: 6, lg: 4));

      &:first-child {
        @include grid-offset((lg: 3));
      }

      &:last-child {
        @include hide-down(md);
      }
    }

    &__link {
      @include reset-link;
      @include text(big, bold);

      display: inline-block;
      outline: none;

      &-arrow {
        display: inline-block;
        transform: translate3d(0, 0, 0);
        transition: transform $base-transition;
      }
    }

    &__link:hover &__link-arrow,
    &__link:focus &__link-arrow {
      transform: translate3d(10px, 0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/FooterNavigation/FooterNavigation.vue